import Vue from "vue";
import VueRouter from "vue-router";
import { checkLogin } from "@/utils/role";
import NProgress from "nprogress";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/docs",
    name: "Docs",
    component: () => import("../views/Docs.vue"),
  },
  {
    path: "/user",
    name: "User",
    redirect: "/user/dash",
    component: () => import("../views/User/User.vue"),
    children: [
      {
        path: "/user/dash",
        name: "Dashboard",
        component: () => import("../views/User/Dashboard.vue"),
      },
      {
        path: "/user/self",
        name: "Self",
        component: () => import("../views/User/Self.vue"),
      },
      {
        path: "/user/history",
        name: "SearchHistory",
        component: () => import("../views/User/SearchHistory.vue"),
      },
      {
        path: "/user/input",
        name: "InputQuestion",
        component: () => import("../views/User/InputQuestion.vue"),
      },
      {
        path: "/user/buy",
        name: "Buy",
        component: () => import("../views/User/Buy.vue"),
      },
      {
        path: "/user/about",
        name: "UserAbout",
        component: () => import("../views/User/About.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// 设置拦截
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
  // 后台写完再开启验证
  if (to.path === "/login" || to.path === "/" || checkLogin()) {
    next();
  } else {
    next({ path: "/login" });
  }
});

router.afterEach(() => {
  NProgress.done();
});
export default router;
